<div class="invoice-roster">
    <header class="invoice-roster-head">
        <div class="invoice-roster-copy">
            <h1>{{ pageTitle }}</h1>
            <p>{{ pageDescription }}</p>
        </div>
        <span class="invoice-roster-count" *ngIf="!loading && !isCompanyView">{{ totalRecords }} fatture</span>
        <div class="invoice-month-select" *ngIf="isCompanyView">
            <label class="form-label" for="invoice-overview-month">Mese</label>
            <p-dropdown
                inputId="invoice-overview-month"
                styleClass="wisper-select"
                panelStyleClass="wisper-select-panel"
                [options]="periodOptions"
                [(ngModel)]="selectedPeriod"
                optionLabel="name"
                optionValue="id"
                [style]="{'width':'14rem'}"
                appendTo="body"
                (onChange)="onOverviewMonthChange()"
            ></p-dropdown>
        </div>
    </header>

    <nav *ngIf="isCompanyView" class="mb-6 flex w-full flex-wrap gap-2 border-b border-slate-200" aria-label="Sezioni report e fatture">
        <button type="button" class="min-h-[44px] border-b-[3px] px-4 py-2 text-sm font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" [class.border-primary]="activeCompanyTab === 'income'" [class.text-strong]="activeCompanyTab === 'income'" [class.border-transparent]="activeCompanyTab !== 'income'" [class.text-slate-600]="activeCompanyTab !== 'income'" [attr.aria-current]="activeCompanyTab === 'income' ? 'page' : null" (click)="selectCompanyTab('income')">
            Entrate mensili
        </button>
        <button type="button" class="min-h-[44px] border-b-[3px] px-4 py-2 text-sm font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" [class.border-primary]="activeCompanyTab === 'welldone'" [class.text-strong]="activeCompanyTab === 'welldone'" [class.border-transparent]="activeCompanyTab !== 'welldone'" [class.text-slate-600]="activeCompanyTab !== 'welldone'" [attr.aria-current]="activeCompanyTab === 'welldone' ? 'page' : null" (click)="selectCompanyTab('welldone')">
            Pagamenti Well Done
        </button>
    </nav>

    <section *ngIf="isCompanyView && activeCompanyTab === 'income'" aria-label="Entrate mensili">
        <div class="mb-5 flex flex-wrap items-end justify-between gap-3 rounded-xl border border-slate-200 bg-white px-5 py-4">
            <div>
                <p class="mb-1 text-sm text-slate-600">Entrate registrate in {{ selectedPeriodLabel() }}</p>
                <strong class="text-2xl font-bold leading-tight text-strong" *ngIf="!overviewLoading && overview">{{ formatAmount(overview.incomeAmount) }}</strong>
                <span class="text-sm text-slate-600" *ngIf="!overviewLoading && !overview">Importo non disponibile</span>
                <div class="invoice-skel invoice-skel-title" *ngIf="overviewLoading"></div>
            </div>
            <span class="text-sm text-slate-600" *ngIf="!overviewLoading && overview">{{ overview.transactions.length }} pagamenti</span>
        </div>

        <div class="mb-3 flex flex-wrap items-start justify-between gap-2">
            <p class="m-0 max-w-2xl text-sm leading-6 text-slate-600">Iscrizioni, rate incassate e pagamenti shop confermati.</p>
            <button type="button" class="inline-flex min-h-[40px] items-center gap-2 rounded-lg px-2 text-sm font-medium text-primary hover:bg-primary-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary" [attr.aria-expanded]="feeHelpOpen" aria-controls="income-fee-help" (click)="feeHelpOpen = !feeHelpOpen">
                <i class="bi bi-question-circle" aria-hidden="true"></i> Come si calcola la commissione?
            </button>
        </div>
        <div id="income-fee-help" *ngIf="feeHelpOpen" class="mb-4 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm leading-6 text-slate-700">
            La commissione Well Done è calcolata secondo la tariffa del piano della società. Per le iscrizioni a rate, qui è ripartita tra le rate a scopo informativo. L'addebito effettivo può avvenire già alla prima rata: il totale dovuto è nel rendiconto della scheda “Pagamenti Well Done”. Il trattino indica che la commissione non è ancora disponibile.
        </div>

        <div class="overflow-x-auto rounded-xl border border-slate-200 bg-white">
            <table class="hidden w-full min-w-[720px] border-collapse text-left text-sm md:table">
                <thead class="bg-slate-50 text-slate-600">
                    <tr>
                        <th scope="col" class="px-4 py-3 font-semibold">Data registrazione</th>
                        <th scope="col" class="px-4 py-3 font-semibold">Pagamento</th>
                        <th scope="col" class="px-4 py-3 font-semibold">Persona</th>
                        <th scope="col" class="px-4 py-3 text-right font-semibold">Incassato</th>
                        <th scope="col" class="px-4 py-3 text-right font-semibold">Commissione</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    <tr *ngIf="overviewLoading"><td colspan="5" class="px-4 py-8 text-center text-slate-600">Caricamento pagamenti…</td></tr>
                    <tr *ngIf="!overviewLoading && !overview"><td colspan="5" class="px-4 py-8 text-center text-slate-600">Non è stato possibile caricare i pagamenti. <button type="button" class="font-semibold text-primary underline" (click)="loadPeriodOverview()">Riprova</button></td></tr>
                    <tr *ngIf="!overviewLoading && overview && !overview.transactions.length"><td colspan="5" class="px-4 py-8 text-center text-slate-600">Nessun pagamento ricevuto in questo mese.</td></tr>
                    <tr *ngFor="let row of !overviewLoading ? (overview?.transactions || []).slice(0, incomeRowsVisible) : []" class="align-top">
                        <td class="whitespace-nowrap px-4 py-4 text-slate-600">{{ formatDate(row.date) }}</td>
                        <td class="px-4 py-4"><span class="font-semibold text-strong">{{ transactionPaymentLabel(row) }}</span><span class="mt-1 block text-slate-600">{{ row.detail || '—' }}<span *ngIf="row.paymentMethod"> · {{ paymentMethodLabel(row.paymentMethod) }}</span></span></td>
                        <td class="px-4 py-4 text-strong">{{ row.label || '—' }}</td>
                        <td class="whitespace-nowrap px-4 py-4 text-right font-semibold text-strong">{{ formatAmount(row.amount) }}</td>
                        <td class="whitespace-nowrap px-4 py-4 text-right"><span class="font-semibold text-strong" *ngIf="row.hasFeeSnapshot">{{ formatAmount(row.feeAmount) }}</span><span class="text-slate-500" *ngIf="!row.hasFeeSnapshot">—</span><span class="block text-xs text-slate-600" *ngIf="row.hasFeeSnapshot && row.feeRate != null">{{ feeRateLabel(row.feeRate) }}</span></td>
                    </tr>
                </tbody>
            </table>
            <div class="divide-y divide-slate-100 md:hidden">
                <p *ngIf="overviewLoading" class="m-0 px-4 py-8 text-center text-sm text-slate-600">Caricamento pagamenti…</p>
                <p *ngIf="!overviewLoading && !overview" class="m-0 px-4 py-8 text-center text-sm text-slate-600">Non è stato possibile caricare i pagamenti. <button type="button" class="font-semibold text-primary underline" (click)="loadPeriodOverview()">Riprova</button></p>
                <p *ngIf="!overviewLoading && overview && !overview.transactions.length" class="m-0 px-4 py-8 text-center text-sm text-slate-600">Nessun pagamento ricevuto in questo mese.</p>
                <article *ngFor="let row of !overviewLoading ? (overview?.transactions || []).slice(0, incomeRowsVisible) : []" class="px-4 py-4 text-sm">
                    <div class="mb-1 flex items-start justify-between gap-3"><strong class="text-strong">{{ transactionPaymentLabel(row) }}</strong><strong class="whitespace-nowrap text-strong">{{ formatAmount(row.amount) }}</strong></div>
                    <p class="mb-2 text-slate-600">{{ row.label || '—' }} · {{ row.detail || '—' }}<span *ngIf="row.paymentMethod"> · {{ paymentMethodLabel(row.paymentMethod) }}</span></p>
                    <div class="flex flex-wrap justify-between gap-2 text-slate-600"><span>{{ formatDate(row.date) }}</span><span>Commissione: {{ row.hasFeeSnapshot ? formatAmount(row.feeAmount) : '—' }}</span></div>
                </article>
            </div>
        </div>
        <button *ngIf="!overviewLoading && overview && overview.transactions.length > incomeRowsVisible" type="button" class="mt-4 min-h-[44px] rounded-lg border border-slate-300 bg-white px-4 text-sm font-semibold text-strong hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary" (click)="incomeRowsVisible = incomeRowsVisible + 25">Mostra altri pagamenti</button>
    </section>

    <ng-container *ngIf="!isCompanyView || activeCompanyTab === 'welldone'">

    <div *ngIf="isCompanyView" class="mb-5">
        <h2 class="mb-1 text-lg font-semibold text-strong">Pagamenti a Well Done</h2>
        <p class="m-0 text-sm leading-6 text-slate-600">Qui trovi il canone, le commissioni e le fatture da scaricare.</p>
    </div>

    <ng-container *ngIf="isCompanyView && !overviewLoading && showStripePaymentCard">
        <h3 *ngIf="!showStripeForecast" class="mb-3 text-base font-semibold text-strong">Prossimo pagamento a Well Done</h3>
        <section class="invoice-summary" aria-label="Stima del prossimo pagamento a Well Done">
            <article class="invoice-summary-card">
                <span>Abbonamento</span>
                <strong>{{ formatStripeOverviewAmount(overview?.nextStripePayment?.planAmount) }}</strong>
                <small>Canone del prossimo addebito</small>
            </article>
            <article class="invoice-summary-card">
                <span>Fee transazioni</span>
                <strong>{{ formatStripeOverviewAmount(overview?.nextStripePayment?.feeAmount) }}</strong>
                <small>Commissioni maturate finora</small>
            </article>
            <article class="invoice-summary-card is-total">
                <span>Totale previsto</span>
                <strong>{{ formatStripeOverviewAmount(overview?.nextStripePayment?.amountDue) }}</strong>
                <small>Stima del prossimo pagamento</small>
            </article>
        </section>
        <p class="invoice-summary-note" *ngIf="overview?.nextStripePayment as payment">
            <span>Addebito previsto il {{ formatDate(payment.expectedAt) }}. Importi stimati da Stripe; le commissioni possono cambiare fino all’emissione della fattura.<span *ngIf="payment.planAmount == null || payment.feeAmount == null"> Il dettaglio di abbonamento e commissioni non è disponibile.</span><span *ngIf="payment.otherAmount != null && payment.otherAmount !== 0"> Il totale include {{ formatStripeOverviewAmount(payment.otherAmount) }} di imposte o altri aggiustamenti.</span></span>
        </p>
        <div *ngIf="!overview?.nextStripePayment" class="invoice-summary-note flex-wrap items-center">
            <span *ngIf="overview?.nextStripePaymentStatus === 'plan_missing'">Il canone non risulta nell’abbonamento Stripe. Contatta l’assistenza prima del prossimo addebito.</span>
            <span *ngIf="overview?.nextStripePaymentStatus === 'none'">Nessun prossimo addebito Stripe previsto.</span>
            <span *ngIf="overview?.nextStripePaymentStatus === 'unavailable' || !overview?.nextStripePaymentStatus">Non riusciamo a mostrare il prossimo pagamento.</span>
            <span *ngIf="overview?.nextStripePaymentStatus === 'not_requested'">Nessuna fattura Well Done registrata in {{ selectedPeriodLabel() }}.</span>
            <button *ngIf="overview?.nextStripePaymentStatus === 'unavailable' || !overview?.nextStripePaymentStatus" type="button" class="min-h-[40px] rounded-lg border border-slate-300 bg-white px-4 text-sm font-semibold text-strong hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary" (click)="loadPeriodOverview()">Riprova</button>
        </div>
    </ng-container>

    <h3 *ngIf="isCompanyView && !overviewLoading && showStripePaymentCard && !showStripeForecast" class="mb-3 text-base font-semibold text-strong">Fatture di {{ selectedPeriodLabel() }}</h3>
    <section class="invoice-summary" *ngIf="isCompanyView && (overviewLoading || (overview && !showStripeForecast))">
        <article class="invoice-summary-card">
            <span>Abbonamento</span>
            <strong *ngIf="!overviewLoading">{{ formatOverviewAmount(overview?.subscriptionAmount) }}</strong>
            <div class="invoice-skel invoice-skel-title" *ngIf="overviewLoading"></div>
            <small>{{ overview?.subscriptionAmount == null ? 'Importo non ancora disponibile' : overview?.subscriptionAmount === 0 ? (overview?.invoice ? 'Nessun canone in questa fattura' : 'Nessun canone previsto nel mese') : 'Canone Well Done del mese' }}</small>
        </article>
        <article class="invoice-summary-card">
            <span>Fee transazioni</span>
            <strong *ngIf="!overviewLoading">{{ formatOverviewAmount(overview?.feeAmount) }}</strong>
            <div class="invoice-skel invoice-skel-title" *ngIf="overviewLoading"></div>
            <small>Commissioni su iscrizioni e ordini</small>
        </article>
        <article class="invoice-summary-card is-total">
            <span>Totale dovuto</span>
            <strong *ngIf="!overviewLoading">{{ formatOverviewAmount(overview?.totalDue) }}</strong>
            <div class="invoice-skel invoice-skel-title" *ngIf="overviewLoading"></div>
            <small>{{ overview?.totalDue == null ? 'Nessun importo confermato' : overview?.projected ? 'Stima del mese in corso' : 'Come da rendiconto' }}</small>
        </article>
    </section>
    <p *ngIf="isCompanyView && !overviewLoading && !overview" class="rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700">Riepilogo del mese non disponibile. <button type="button" class="font-semibold text-primary underline" (click)="loadPeriodOverview()">Riprova</button></p>
    <p class="invoice-summary-note" *ngIf="isCompanyView && overview?.projected && overview?.totalDue != null">
        La fattura del mese viene emessa a fine periodo. Questi importi sono la stima aggiornata di quanto risulterà dovuto.
    </p>

    <form class="invoice-roster-toolbar" (submit)="$event.preventDefault(); applyFilters()">
        <input
            type="search"
            class="form-control form-control-solid"
            [(ngModel)]="textFilter"
            name="invoiceSearch"
            [placeholder]="isCompanyView ? 'Cerca numero fattura' : 'Cerca numero fattura o società'"
            (keyup.enter)="applyFilters()"
        />
        <button
            type="button"
            class="btn welldone-btn-gray user-filter-trigger"
            [class.is-open]="!!activeFilterCount"
            (click)="filtersPanel.toggle($event)"
        >
            <i class="bi bi-funnel" aria-hidden="true"></i>
            Filtri
            <span class="user-filter-badge" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
        </button>
        <button type="submit" class="btn btn-primary">Cerca</button>
        <button type="button" class="btn btn-reset-link" *ngIf="hasActiveQuery" (click)="resetAll()">Reset</button>
    </form>

    <p-overlayPanel #filtersPanel [dismissable]="false" styleClass="user-filter-popover">
        <div class="user-filter-form">
            <div class="user-filter-field" *ngIf="!isCompanyView">
                <label class="form-label" for="invoice-period">Mese</label>
                <p-dropdown
                    inputId="invoice-period"
                    styleClass="wisper-select"
                    panelStyleClass="wisper-select-panel"
                    [options]="periodOptions"
                    [(ngModel)]="selectedPeriod"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Tutti i mesi"
                    [showClear]="true"
                    [filter]="true"
                    filterPlaceHolder="Cerca mese"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-dropdown>
            </div>

            <div class="user-filter-field" *ngIf="canFilterCompanies">
                <label class="form-label" for="invoice-company">Società</label>
                <p-multiSelect
                    inputId="invoice-company"
                    styleClass="wisper-multiselect"
                    panelStyleClass="wisper-multiselect-panel"
                    [options]="companies"
                    [(ngModel)]="selectedCompanyIds"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Tutte"
                    display="chip"
                    [filter]="true"
                    filterPlaceHolder="Cerca società"
                    [showToggleAll]="true"
                    [resetFilterOnHide]="true"
                    emptyFilterMessage="Nessun risultato"
                    selectedItemsLabel="{0} società"
                    [maxSelectedLabels]="2"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-multiSelect>
            </div>

            <div class="user-filter-field">
                <label class="form-label" for="invoice-status">Stato pagamento</label>
                <p-multiSelect
                    inputId="invoice-status"
                    styleClass="wisper-multiselect"
                    panelStyleClass="wisper-multiselect-panel"
                    [options]="statusOptions"
                    [(ngModel)]="selectedStatusIds"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Tutti"
                    display="chip"
                    [showToggleAll]="false"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-multiSelect>
            </div>

            <div class="user-filter-field">
                <label class="form-label" for="invoice-method">Metodo di pagamento</label>
                <p-multiSelect
                    inputId="invoice-method"
                    styleClass="wisper-multiselect"
                    panelStyleClass="wisper-multiselect-panel"
                    [options]="methodOptions"
                    [(ngModel)]="selectedMethodIds"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Tutti"
                    display="chip"
                    [showToggleAll]="false"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-multiSelect>
            </div>

            <div class="user-filter-field">
                <label class="form-label" for="invoice-sort">Ordina per</label>
                <p-dropdown
                    inputId="invoice-sort"
                    styleClass="wisper-select"
                    panelStyleClass="wisper-select-panel"
                    [options]="sortOptions"
                    [(ngModel)]="sortBy"
                    optionLabel="name"
                    optionValue="id"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-dropdown>
            </div>

            <div class="user-filter-actions">
                <button type="button" class="btn btn-reset-link" (click)="clearAdvancedFilters()">Azzera</button>
                <button type="button" class="btn btn-primary" (click)="applyFilters()">Applica</button>
            </div>
        </div>
    </p-overlayPanel>

    <p-table
        [value]="invoices"
        dataKey="id"
        [lazy]="true"
        [paginator]="true"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [loading]="loading"
        [rowsPerPageOptions]="[30,50,100]"
        [rowHover]="true"
        responsiveLayout="scroll"
        styleClass="invoice-roster-table"
        paginatorDropdownAppendTo="body"
        currentPageReportTemplate="{first}–{last} di {totalRecords}"
        [showCurrentPageReport]="true"
        (onLazyLoad)="loadInvoices($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Fattura</th>
                <th *ngIf="!isCompanyView">Società</th>
                <th>Periodo</th>
                <th>Importo</th>
                <th>Stato</th>
                <th>Documenti</th>
                <th class="invoice-col-actions">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr class="invoice-roster-row" (click)="openInvoiceDetail(row)">
                <td>
                    <div class="invoice-identity">
                        <div class="invoice-mark" aria-hidden="true">
                            <i class="bi bi-receipt"></i>
                        </div>
                        <div class="invoice-identity-text">
                            <span class="invoice-number">{{ row.number }}</span>
                            <span class="invoice-date">{{ formatDate(row.date) }}</span>
                        </div>
                    </div>
                </td>
                <td *ngIf="!isCompanyView">
                    <div class="invoice-company" *ngIf="row.company?.name; else noCompany">
                        <i class="bi bi-building" aria-hidden="true"></i>
                        <span>{{ row.company?.name }}</span>
                    </div>
                    <ng-template #noCompany>
                        <span class="invoice-muted">—</span>
                    </ng-template>
                </td>
                <td>
                    <span class="invoice-period">{{ formatPeriod(row.billingPeriodStart, row.billingPeriodEnd) }}</span>
                </td>
                <td>
                    <div class="invoice-amount-block">
                        <span class="invoice-amount">{{ formatAmount(row.amount) }}</span>
                        <span class="invoice-method">{{ paymentMethodLabel(row.paymentMethod) }}</span>
                        <span class="invoice-fee" *ngIf="feeAmount(row) > 0">
                            di cui {{ formatAmount(feeAmount(row)) }} commissioni
                        </span>
                    </div>
                </td>
                <td>
                    <span class="badge" [ngClass]="paymentStatusBadgeClass(row.paymentStatus)">
                        {{ paymentStatusLabel(row.paymentStatus) }}
                    </span>
                </td>
                <td (click)="$event.stopPropagation()">
                    <div class="invoice-docs">
                        <a
                            *ngIf="hasReport(row); else missingReport"
                            class="invoice-doc"
                            [href]="row.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Apri il rendiconto dei servizi e delle commissioni"
                        >
                            <span class="invoice-doc-icon is-report">
                                <i class="bi bi-file-earmark-bar-graph" aria-hidden="true"></i>
                            </span>
                            <span class="invoice-doc-copy">
                                <strong>Rendiconto</strong>
                                <small>Servizi e commissioni</small>
                            </span>
                        </a>
                        <ng-template #missingReport>
                            <span class="invoice-doc is-missing">
                                <span class="invoice-doc-icon is-report">
                                    <i class="bi bi-file-earmark-bar-graph" aria-hidden="true"></i>
                                </span>
                                <span class="invoice-doc-copy">
                                    <strong>Rendiconto</strong>
                                    <small>Non disponibile</small>
                                </span>
                            </span>
                        </ng-template>

                        <button *ngIf="row.stripeInvoiceId" type="button" class="invoice-doc w-full text-left" (click)="openStripeInvoice(row)" title="Apri il documento Stripe">
                            <span class="invoice-doc-icon is-fiscal"><i class="bi bi-download" aria-hidden="true"></i></span>
                            <span class="invoice-doc-copy"><strong>Documento Stripe</strong><small>PDF Stripe, se disponibile</small></span>
                        </button>
                        <a
                            *ngIf="hasFiscalInvoice(row); else missingFiscal"
                            class="invoice-doc"
                            [href]="row.fattureInCloudDocumentUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Apri la fattura fiscale emessa su Fatture in Cloud"
                        >
                            <span class="invoice-doc-icon is-fiscal">
                                <i class="bi bi-receipt-cutoff" aria-hidden="true"></i>
                            </span>
                            <span class="invoice-doc-copy">
                                <strong>Fattura fiscale</strong>
                                <small>Fatture in Cloud</small>
                            </span>
                        </a>
                        <ng-template #missingFiscal>
                            <span class="invoice-doc is-missing" *ngIf="!row.stripeInvoiceId">
                                <span class="invoice-doc-icon is-fiscal">
                                    <i class="bi bi-receipt-cutoff" aria-hidden="true"></i>
                                </span>
                                <span class="invoice-doc-copy">
                                    <strong>Fattura fiscale</strong>
                                    <small>PDF non disponibile</small>
                                </span>
                            </span>
                        </ng-template>
                    </div>
                </td>
                <td class="invoice-col-actions" (click)="$event.stopPropagation()">
                    <div class="invoice-actions">
                        <button
                            type="button"
                            class="btn welldone-btn-gray"
                            title="Dettagli"
                            (click)="openInvoiceDetail(row)"
                        >
                            <i class="bi bi-eye" aria-hidden="true"></i>
                        </button>
                        <button
                            *ngIf="userIsAdmin && row.paymentStatus !== 'paid' && !row.stripeInvoiceId"
                            type="button"
                            class="btn welldone-btn-gray"
                            title="Segna come pagata"
                            (click)="markAsPaid(row.id)"
                        >
                            <i class="bi bi-check2-circle" aria-hidden="true"></i>
                        </button>
                        <button
                            *ngIf="userIsAdmin"
                            type="button"
                            class="btn welldone-btn-gray"
                            title="Rigenera rendiconto"
                            [disabled]="regeneratingInvoiceId === row.id"
                            (click)="regenerateReport(row.id)"
                        >
                            <i class="bi" [ngClass]="regeneratingInvoiceId === row.id ? 'bi-arrow-repeat' : 'bi-arrow-clockwise'" aria-hidden="true"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <tr *ngFor="let row of skeletonRows">
                <td>
                    <div class="invoice-identity">
                        <div class="invoice-skel invoice-skel-mark"></div>
                        <div class="invoice-identity-text">
                            <div class="invoice-skel invoice-skel-title"></div>
                            <div class="invoice-skel invoice-skel-line"></div>
                        </div>
                    </div>
                </td>
                <td *ngIf="!isCompanyView"><div class="invoice-skel invoice-skel-company"></div></td>
                <td><div class="invoice-skel invoice-skel-company"></div></td>
                <td><div class="invoice-skel invoice-skel-title"></div></td>
                <td><div class="invoice-skel invoice-skel-chip"></div></td>
                <td>
                    <div class="invoice-docs">
                        <div class="invoice-skel invoice-skel-doc"></div>
                        <div class="invoice-skel invoice-skel-doc"></div>
                    </div>
                </td>
                <td class="invoice-col-actions">
                    <div class="invoice-actions">
                        <div class="invoice-skel invoice-skel-btn"></div>
                        <div class="invoice-skel invoice-skel-btn"></div>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columnCount" class="invoice-empty">Nessuna fattura trovata. Prova a cambiare ricerca o filtri.</td>
            </tr>
        </ng-template>
    </p-table>

    </ng-container>
</div>

<p-sidebar
    [(visible)]="detailOpen"
    position="right"
    [modal]="true"
    [blockScroll]="true"
    [showCloseIcon]="false"
    [dismissible]="true"
    styleClass="user-tessera-sidebar"
>
    <ng-container *ngIf="selectedInvoice">
        <div class="tessera-hero">
            <button type="button" class="tessera-close" aria-label="Chiudi" (click)="detailOpen = false">
                <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
            <span class="tessera-mark">
                <i class="bi bi-receipt" aria-hidden="true"></i>
            </span>
            <h2>{{ selectedInvoice.number }}</h2>
            <p>{{ selectedInvoice.company?.name || 'Nessuna società' }}</p>
            <span class="badge" [ngClass]="paymentStatusBadgeClass(selectedInvoice.paymentStatus)">
                {{ paymentStatusLabel(selectedInvoice.paymentStatus) }}
            </span>
            <button
                type="button"
                class="tessera-id"
                (click)="copyValue(selectedInvoice.id, 'id')"
                [disabled]="!selectedInvoice.id"
            >
                <span>{{ selectedInvoice.id || '—' }}</span>
                <i class="bi" [ngClass]="copiedKey === 'id' ? 'bi-check2' : 'bi-clipboard'" aria-hidden="true"></i>
            </button>
        </div>

        <div class="tessera-body">
            <section>
                <h3>Importi</h3>
                <div class="tessera-field">
                    <span>Totale</span>
                    <strong>{{ formatAmount(selectedInvoice.amount) }}</strong>
                </div>
                <div class="tessera-field">
                    <span>Commissioni</span>
                    <strong>{{ feeAmount(selectedInvoice) > 0 ? formatAmount(feeAmount(selectedInvoice)) : '—' }}</strong>
                </div>
                <div class="tessera-field">
                    <span>Metodo</span>
                    <strong>{{ paymentMethodLabel(selectedInvoice.paymentMethod) }}</strong>
                </div>
            </section>

            <section>
                <h3>Periodo</h3>
                <div class="tessera-field">
                    <span>Data fattura</span>
                    <strong>{{ formatDate(selectedInvoice.date) }}</strong>
                </div>
                <div class="tessera-field">
                    <span>Competenza</span>
                    <strong>{{ formatPeriod(selectedInvoice.billingPeriodStart, selectedInvoice.billingPeriodEnd) }}</strong>
                </div>
            </section>

            <section>
                <h3>Società</h3>
                <div class="tessera-field">
                    <span>Nome</span>
                    <strong>{{ selectedInvoice.company?.name || '—' }}</strong>
                </div>
                <div class="tessera-field" *ngIf="selectedInvoice.stripeInvoiceId">
                    <span>Stripe</span>
                    <strong>{{ selectedInvoice.stripeInvoiceId }}</strong>
                </div>
                <a
                    *ngIf="selectedInvoice.companyId"
                    class="btn welldone-btn-gray"
                    [routerLink]="['/companies/' + selectedInvoice.companyId + '/settings']"
                >
                    Apri società
                </a>
            </section>

            <section>
                <h3>Documenti</h3>
                <div class="invoice-docs invoice-docs--stack">
                    <a
                        *ngIf="hasReport(selectedInvoice); else detailMissingReport"
                        class="invoice-doc"
                        [href]="selectedInvoice.url"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span class="invoice-doc-icon is-report">
                            <i class="bi bi-file-earmark-bar-graph" aria-hidden="true"></i>
                        </span>
                        <span class="invoice-doc-copy">
                            <strong>Rendiconto</strong>
                            <small>Dettaglio servizi e commissioni del periodo</small>
                        </span>
                    </a>
                    <ng-template #detailMissingReport>
                        <span class="invoice-doc is-missing">
                            <span class="invoice-doc-icon is-report">
                                <i class="bi bi-file-earmark-bar-graph" aria-hidden="true"></i>
                            </span>
                            <span class="invoice-doc-copy">
                                <strong>Rendiconto</strong>
                                <small>PDF non ancora disponibile</small>
                            </span>
                        </span>
                    </ng-template>

                    <button *ngIf="selectedInvoice.stripeInvoiceId" type="button" class="invoice-doc w-full text-left" (click)="openStripeInvoice(selectedInvoice)">
                        <span class="invoice-doc-icon is-fiscal"><i class="bi bi-download" aria-hidden="true"></i></span>
                        <span class="invoice-doc-copy"><strong>Documento Stripe</strong><small>PDF Stripe, se disponibile</small></span>
                    </button>
                    <a
                        *ngIf="hasFiscalInvoice(selectedInvoice); else detailMissingFiscal"
                        class="invoice-doc"
                        [href]="selectedInvoice.fattureInCloudDocumentUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span class="invoice-doc-icon is-fiscal">
                            <i class="bi bi-receipt-cutoff" aria-hidden="true"></i>
                        </span>
                        <span class="invoice-doc-copy">
                            <strong>Fattura fiscale</strong>
                            <small>Documento elettronico Fatture in Cloud</small>
                        </span>
                    </a>
                    <ng-template #detailMissingFiscal>
                        <span class="invoice-doc is-missing" *ngIf="!selectedInvoice.stripeInvoiceId">
                            <span class="invoice-doc-icon is-fiscal">
                                <i class="bi bi-receipt-cutoff" aria-hidden="true"></i>
                            </span>
                            <span class="invoice-doc-copy">
                                <strong>Fattura fiscale</strong>
                                <small>PDF non disponibile</small>
                            </span>
                        </span>
                    </ng-template>
                </div>
            </section>
        </div>

        <footer class="tessera-footer" *ngIf="userIsAdmin">
            <button
                *ngIf="selectedInvoice.paymentStatus !== 'paid' && !selectedInvoice.stripeInvoiceId"
                type="button"
                class="btn welldone-btn-gray"
                (click)="markAsPaid(selectedInvoice.id)"
            >
                Segna come pagata
            </button>
            <button
                type="button"
                class="btn welldone-btn-gray"
                [disabled]="regeneratingInvoiceId === selectedInvoice.id"
                (click)="regenerateReport(selectedInvoice.id)"
            >
                {{ regeneratingInvoiceId === selectedInvoice.id ? 'Rigenerazione...' : 'Rigenera rendiconto' }}
            </button>
        </footer>
    </ng-container>
</p-sidebar>
